export enum Browser {
    chrome = 'chrome',
    ie = 'ie',
    opera = 'opera',
    safari = 'safari',
    firefox = 'firefox',
}
